/**
 *   Created by FANGlh on 2019/1/16 17:32.
 *   Desc: 成绩通知
 */

import React, {Component} from 'react';
import '../score-inquiry/ScoreInquiry.css';
import ScoreData from '../score-inquiry/ScoreData';
import {fetchPost, fetchGet, fetchGetNoSession} from '../../../utils/fetchRequest';
import {API} from '../../../configs/api.config';
import {Toast, Picker} from 'antd-mobile';
import {connect} from 'react-redux';
import RefreshLayout from "../../../components/RefreshLayout";
import {Button, Icon, Input, List, Skeleton} from 'antd';
import {getIntValue, getStrValue, isObjEmpty} from "../../../utils/common";

let pageIndex = 0
let pageSize = 10

class ScoreNotification extends Component {
    constructor() {
        super();
        this.state = {
            stuId: '',
            selectClass: '',
            selectTime: '',
            ScoreDataList: [],
            scoreNames: [],
            scoreTypes: [],
            isRefreshing: false,
            isLoading: true,
        }
    }

    componentWillMount() {
        document.title = '成绩通知'
    }

    componentDidMount() {
        let stuId
        if (this.props.match.params.stuId) {
            stuId = this.props.match.params.stuId
        } else {
            stuId = this.props.userInfo.user.student.stuId
        }
        this.setState({
            stuId: stuId
        }, function () {
            pageIndex = 0
            this.getScoreData()
        })
    }

    render() {
        return (
            <div className="this_contaior">
                <RefreshLayout
                    refreshing={this.state.isRefreshing}
                    // ref={el => {
                    //     this.container = el
                    // }}
                    onRefresh={this.getScoreData}>
                    <Skeleton loading={this.state.isLoading} active paragraph={{rows: 3}}>
                        <List dataSource={this.state.ScoreDataList}
                              renderItem={itemdata => (
                                  <List.Item>
                                      <ScoreData itemdata={itemdata}></ScoreData>
                                  </List.Item>
                              )}/>
                    </Skeleton>
                </RefreshLayout>
            </div>
        )
    }

    getScoreData = () => {
        if (isObjEmpty(this.state.stuId)) {
            return
        }
        try {
            this.setState({
                isRefreshing: true
            })
        } catch (e) {
        }
        pageIndex++
        let params = {
            stuId: this.state.stuId,
            pageIndex: pageIndex,
            pageSize: pageSize
        }
        console.log('params', params)
        fetchPost(API.getScoreByStu, params, {})
            .then((response) => {
                if (response.success && !isObjEmpty(response.data) && response.data[0].schoolAverage != "NaN") {
                    if (pageIndex == 1) {
                        this.setState({
                            ScoreDataList: response.data
                        })
                    } else {
                        this.setState({
                            ScoreDataList: this.state.ScoreDataList.push(response.data)
                        })
                    }
                }else {
                    Toast.info("暂无学校的最新通知公告信息，学校发布后，您可以在公众号及时收到通知信息推送，谢谢！", 2)
                }

                this.setState({
                    isRefreshing: false,
                    isLoading: false
                })
            })
            .catch((error) => {
                if (typeof error === 'string') {
                    Toast.fail(error, 2)
                } else {
                    Toast.fail('请求异常', 2)
                }
                this.setState({
                    isRefreshing: false,
                    isLoading: false
                })
            })
    }

}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ScoreNotification)